// material-ui
import {} from '@mui/material'
import { useParams } from 'react-router-dom'

import { Avatar, AvatarGroup, Grid, Typography } from '@mui/material'
import SubCard from 'ui-component/cards/SubCard'

import { gridSpacing } from 'store/constant'

// assets
import * as autoThunks from 'features/auto-thunks'
import { useEffect } from 'react'

import { getUserClaims } from 'features/application/application-slice'
import {
  get_all_contentHouse,
  get_selected_contentHouse,
  setSelectedcontentHouse,
} from 'features/contentHouse/contentHouse-slice'
import { useDispatch, useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid
  const params = useParams()
  let dispatch = useDispatch()
  let claims = useSelector(getUserClaims)
  let contentHouse_list = useSelector(get_all_contentHouse)
  let contentHouse = useSelector(get_selected_contentHouse)

  useEffect(() => {
    if (claims?.user && params?.id) {
      dispatch(
        autoThunks.load_existing_content_houses({
          fire_user: claims?.user,
          contentHouseId: params?.id,
        }),
      )
    }
  }, [claims?.user, params?.id])
  useEffect(() => {
    function set_local_content_house() {
      let contentHouse = contentHouse_list.find((x) => x.id === params.id)
      if (contentHouse) {
        dispatch(setSelectedcontentHouse(contentHouse.id))
      }
    }
    set_local_content_house()
  }, [contentHouse_list, contentHouse?.id])

  function _(): any {
    return contentHouse
  }

  function ContentHouseTitle(contentHouse: any): any {
    return (
      <>
        <Grid container spacing={2} alignItems="center">
          <Grid item>
            <Avatar alt="User 1" src={contentHouse?.contentHouseProfileImage} />
          </Grid>
          <Grid item xs zeroMinWidth>
            <Typography align="left" variant="subtitle1">
              {contentHouse?.name}
            </Typography>
            <Typography align="left" variant="subtitle2">
              {contentHouse?.description}
            </Typography>
          </Grid>
        </Grid>
      </>
    )
  }

  let output_ContentHouseTitle = ContentHouseTitle(_())

  function _child(): any {
    return (
      <Grid container justifyContent="center">
        <AvatarGroup max={4}>
          {(contentHouse?.members || []).map((v, index) => {
            return (
              <Avatar
                alt={v.name}
                title={v.name}
                src={v?.profileImage}
                key={index}
              />
            )
          })}
        </AvatarGroup>
      </Grid>
    )
  }

  let output__child = _child()

  function subcard(title: any, child: any): any {
    return <SubCard title={title}>{child}</SubCard>
  }

  let output_subcard = subcard(output_ContentHouseTitle, output__child)

  function grid(child1: any, child2: any): any {
    return (
      <Grid container spacing={gridSpacing}>
        <Grid item lg={4} xs={12}>
          {child1}
        </Grid>
        <Grid item lg={8} xs={12}>
          {child2}
        </Grid>
      </Grid>
    )
  }

  let output_grid = grid(output_subcard, null)

  return output_grid
}
